export enum CategoryEnum {
    residentialForRent = 4233,
    residentialForSale = 3399,
    lifeStyle = 9120,
    newHomesNewApartment = 7280,
    newHomesNewTownhouseAndTerraced = 7281,
    newHomesHouseAndLand = 7282,
    newHomesNewHouse = 7283,
    boatsAndMarineMotorboats = 30,
    sectionsForSale = 3400,
    rural = 5745
}

export const NEW_HOMES_CATEGORIES: CategoryEnum[] = [
    CategoryEnum.newHomesNewApartment,
    CategoryEnum.newHomesNewTownhouseAndTerraced,
    CategoryEnum.newHomesHouseAndLand,
    CategoryEnum.newHomesNewHouse
];
